import { breadcrumb } from './breadcrumb';

export const hlr = {
  breadcrumb,

  requests: {
    index: 'Запросы',
    create_request: 'Создать запрос',

    status: {
      pending: 'В ожидании',
      processing: 'В процессе',
      rejected: 'Отклонено',
      failed: 'Ошибка',
      success: 'Успешно'
    },
    download: {
      tooltip: 'Экспорт'
    },
    upload: {
      success: 'Запрос успешно создан'
    }
  }
};
